Namespace 'CustomerVisualMode.Mappers'

class CustomerVisualMode.Mappers.ExcludedValueSetMapper
  constructor: (excludedKey) ->
    @excludedKey = excludedKey
    @excluded_logic_key = excludedKey + '_logic'

  mapToCompositeFilter: (intelligentGroups) ->
    newValues = {}
    values = intelligentGroups[@excludedKey]
    return newValues if !values || values?.length == 0

    {
      excluded: {
        values: values,
        operator: intelligentGroups[@excluded_logic_key]?.toLowerCase() || 'or'
      }
    }

  mapToSearchQuery: (intelligentGroups) ->
    return {} unless intelligentGroups.excluded

    {
      "#{@excludedKey}": intelligentGroups.excluded.values,
      "#{@excluded_logic_key}": intelligentGroups.excluded.operator?.toLowerCase() || 'or'
    }
